export class BackStoryData {
  static ideology = () => [
    '崇拝して祈りを捧げる崇高な存在がある',
    '人類は宗教なしでやっていける',
    '科学にはすべての答えがある',
    '運命への信念',
    '社会、あるいは秘密結社の一員である',
    '社会には根絶すべき悪がある',
    'オカルト',
    '政治',
    'お金は力であり、得られるものはすべて得るつもりだ',
    '運動員/活動家',
  ];

  static keyPerson = () => [
    '親',
    '祖父母',
    '兄弟姉妹',
    '子供',
    'パートナー',
    '探索者の最も高い職業技能を教えてくれた人',
    '幼なじみ',
    '有名人。あなたのアイドルか英雄',
    '仲間の探索者',
    'NPC',
  ];

  static reason = () => [
    '彼らの世話になっている',
    '彼らは何かを教えてくれた',
    '彼らはあなたに人生の意味を与えてくれた',
    'あなたは彼らを不当に扱い、和解を求めている',
    '経験を共有している',
    'あなたは自分を彼らに認めてもらいたいと思っている',
    '彼らを偶像化している',
    '後悔',
    'あなたは自分が彼らより優れていることを証明したいと思っている',
    '彼らはあなたの邪魔をした。あなたはそれに復讐したいと思っている',
  ];

  static keyPoint = () => [
    'あなたの学び舎',
    'あなたの故郷',
    'あなたの初恋の場所',
    '落ち着いた、塾考できる場所',
    '社交的な場所',
    'あなたの「イデオロギー/信念」に関連する場所',
    '重要な人々の墓',
    'あなたの実家',
    '人生であなたが最も幸福であった場所',
    'あなたの仕事場',
  ];

  static precious = () => [
    'あなたの最も高い技能に関連したアイテム',
    'あなたの職業にとって不可欠なアイテム',
    'あなたの幼少期の思い出の品',
    '去っていった人物の形見',
    'あなたの重要な人々にあげた何か',
    'あなたのコレクション',
    'あなたが見つけた何か。ただし、あなたはそれがなんであるかを知らず、答えを求めている',
    'スポーツ用具',
    '武器',
    'ペット',
  ];

  static characteristic = () => [
    '寛大',
    '動物に懐かれやすい',
    '夢見る人',
    '快楽主義者',
    'ギャンブラーおよび冒険家',
    '料理が上手',
    '色男/男たらし',
    '忠誠心が強い',
    '良い評判',
    '野心的',
  ];
}
